module.exports = __webpack_public_path__ + "static/img/massage_img3.ec6e989a.png";